import { SignatureScope } from './Transaction';

export enum TokenDeliveryMethod {
  EMAIL = 'email',
  PHONE = 'sms',
}

export enum TokenType {
  SIGNATURE = 'signature',
  VERIFICATION = 'verification',
}

export enum TokenState {
  NEW = 'new',
  REPLACED = 'replaced',
  USED = 'used',
}

export interface Token {
  _id: string;
  createdAt: string;
  updatedAt: string;
  owner: string;
  tags: TokenDeliveryMethod[];
  status: TokenState;
  type: TokenType;
  publicKey: string;
  meta: {
    attempts: number;
    deliveryDetail: string;
    scopes?: SignatureScope[];
    transactionId: string;
  };
}
